import '../scss/btf/btf.scss';
import { onDomContentLoaded } from "./utils";

onDomContentLoaded(() => {
    if (document.querySelector('#on-ready-modal')) {
        import('./components/on-ready-modal/on-ready-modal').then(({ OnReadyModal }) => new OnReadyModal());
    }

    if (document.querySelector('.navbar')) {
        import('./components/navbar/navbar').then(({ Navbar }) => new Navbar());
    }

    if (document.querySelector('.lang-switcher .lang-switcher__toggler[aria-controls]')) {
        import('./components/lang-switcher/lang-switcher').then(({ LangSwitcher }) => new LangSwitcher());
    }

    if (document.querySelector('.search-box')) {
        import('./components/search-box/search-box').then(({ SearchBox }) => new SearchBox());
    }

    if (document.querySelector('.menu .menu__link[aria-controls]')) {
        import('./components/menu/menu').then(({ Menu }) => new Menu());
    }

    if (document.querySelector('.accordion .accordion__btn[aria-controls]')) {
        import('./components/accordion/accordion').then(({ Accordion }) => new Accordion());
    }

    if (document.querySelector('.tabs .tabs__btn[aria-controls]')) {
        import('./components/tabs/tabs').then(({ Tabs }) => new Tabs());
    }

    if (document.querySelector('.hero__slider')) {
        import('./components/hero-slider/hero-slider').then(({ HeroSlider }) => new HeroSlider());
    }

    if (document.querySelector('.hero__embed')) {
        import('./components/hero-embed/hero-embed').then(({ HeroEmbed }) => new HeroEmbed());
    }

    if (document.querySelector('.team-slider')) {
        import('./components/team-slider/team-slider').then(({ TeamSlider }) => new TeamSlider());
    }

    if (document.querySelector('.projects-slider')) {
        import('./components/projects-slider/projects-slider').then(({ ProjectsSlider }) => new ProjectsSlider());
    }

    if (document.querySelector('.tags')) {
        import('./components/tags/tags').then(({ Tags }) => new Tags());
    }

    if (document.querySelector('.gallery-grid')) {
        import('./components/gallery-grid/gallery-grid').then(({ GalleryGrid }) => new GalleryGrid());
    }

    if (document.querySelector('.gallery-slider')) {
        import('./components/gallery-slider/gallery-slider').then(({ GallerySlider }) => new GallerySlider());
    }

    if (document.querySelector('#gallery-modal')) {
        import('./components/gallery-modal/gallery-modal').then(({ GalleryModal }) => new GalleryModal());
    }

    if (document.querySelector('.news-ticker')) {
        import('./components/news-ticker/news-ticker').then(({ NewsTicker }) => new NewsTicker());
    }

    if (document.querySelector('.brands-slider')) {
        import('./components/brands-slider/brands-slider').then(({ BrandsSlider }) => new BrandsSlider());
    }

    if (document.querySelector('.project-list-form')) {
        import('./components/project-list-form/project-list-form').then(({ ProjectListForm }) => new ProjectListForm());
    }

    if (document.querySelector('.attachments-form')) {
        import('./components/attachments-form/attachments-form').then(({ AttachmentsForm }) => new AttachmentsForm());
    }

    if (document.querySelector('.news-slider')) {
        import('./components/news-slider/news-slider').then(({ NewsSlider }) => new NewsSlider());
    }
});
